export default class DownloadsComponent {
    constructor() {
        let listResources = document.querySelector(".list-resource");
        let blocks = listResources.querySelectorAll(".block");

        if (blocks.length > 6) {
            listResources.classList.add("collapse");
        } else {
            document.querySelector(".show-more").classList.add('hide');
        }

        document.querySelector(".show-more").addEventListener("click", function () {
            listResources.classList.remove('collapse');
            document.querySelector(".show-more").classList.add('hide');
        })

        this.scrollTo('.resources_component')
    }

    scrollTo(element) {
        function offset(el) {
            let rect = el.getBoundingClientRect(),
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
        }

        let filterComponent = offset(document.querySelector(element));

        if (window.location.pathname.split('/').length > 5) {
            window.scroll({ top: (filterComponent.top - 30), left: 0, behavior: 'smooth' })
        }
    }
}
new DownloadsComponent();